<template>

  <div v-if="examenesAuxiliares" class="">
    <b-alert 
      v-for="(item, index) in examenesAuxiliares" 
      :key="index" show 
      :variant="getVariantAlert(item.accion)" 
      class="my-1 p-2 position-relative card-labs"
    >
  
      <div style="position: absolute; top: 10px; right: 10px; z-index: 10;">
        
        <small class="text-muted mr-1">{{ getTextAccion(item.accion) }}</small>
  
        <b-button
          v-if="canEditItem(item)"
          variant="warning" 
          size="sm"
          class="card-button"
          @click="onEditItem(index)"
        >
          <i class="fa-solid fa-pen"/>
        </b-button>
  
        <b-button
          v-if="canDeleteItem(item)"
          variant="danger" 
          size="sm"
          class="card-button"
          @click="removeLaboratorioAuxiliar(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>
  
        <b-button
          v-if="item.accion === 'eliminar'"
          variant="warning" 
          size="sm"
          class="ml-1"
          @click="restoreLaboratorioAuxiliar(index)"
          title="Restaurar"
        >
          <i class="fa-solid fa-rotate-left"/>
        </b-button>
      </div>
  
      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Estado: </strong> 
        <span class="text-dark">{{ getEstadoLabText(item.estadoLaboratorio) }}</span>
      </b-row>
  
      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Codigo: </strong> 
        <span class="text-dark">{{ item.codigoOrden }}</span>
      </b-row>
  
      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Laboratorios: </strong> 
  
        <div class="">
          <div 
            v-for="(lab, index) in item.laboratorios" 
            :key="index"
            class="text-dark"
          >
            {{ lab.text }}
          </div>
        </div>
        
      </b-row>
  
      <span v-if="item.justificacion">
        <b-row class="d-flex align-items-center mt-1">
          <strong class="item-label">Justificacion: </strong> 
          <span class="text-secondary">{{ item.justificacion }}</span> <br/>
        </b-row>
      </span>
        
    </b-alert>
  </div>
</template>

<script>

export default {

  name: "CardEnvioLaboratorios",

  props: {
    examenesAuxiliares: {
      type: Array,
      default: () => []
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },



  data() {
    return {
      showCardComplete: [],
    }
  },
  

  methods:{

    getVariantAlert(tipoAccion){
      if(tipoAccion === 'registrado')  return 'success';
      if(tipoAccion === 'editar')   return 'warning';
      if(tipoAccion === 'eliminar') return 'danger';

      return 'info';
    },


    getTextAccion(tipoAccion){

      if(tipoAccion === 'registrado')  return 'REGISTRADO';
      if(tipoAccion === 'crear')       return 'POR CREAR';
      if(tipoAccion === 'editar')      return 'POR EDITAR';
      if(tipoAccion === 'eliminar')    return 'POR ELIMINAR';

      return '';
    },


    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists 
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },

    canEditItem(item){
      const estadoValido = parseInt(item.estadoLaboratorio) < 3;
      return estadoValido && !this.onlyView
    },

    canDeleteItem(item){
      const estadoValido = parseInt(item.estadoLaboratorio) < 3;
      return item.accion !== 'eliminar' && estadoValido && !this.onlyView
    },


    onEditItem(index){
      this.navigateToQuery("editAux", index);
    },


    async removeLaboratorioAuxiliar(index) {
      
      const result = await this.$swal({
        title: '¿Estás seguro de eliminar este examen de laboratorio?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'No, cancelar'
      })

      if (!result.isConfirmed) return;


      if(this.examenesAuxiliares[index].accion !== 'crear'){
        this.examenesAuxiliares[index].accion = 'eliminar';
        return;
      }

      this.examenesAuxiliares.splice(index, 1);

      // const itemList = this.examenesAuxiliares[index];

      // if (itemList.accion === 'crear'){
      //   this.examenesAuxiliares = this.examenesAuxiliares.filter(
      //     (item, i) => i !== index
      //   );
      //   return;
      // } 
        
      // this.examenesAuxiliares[index].accion = 'eliminar';
    },


    async restoreLaboratorioAuxiliar(index){
      this.examenesAuxiliares[index].accion = 'registrado';
    },

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },


    getEstadoLabText(estado){
      if(estado === '1') return 'Creado';
      if(estado === '2') return 'Programado';
      if(estado === '3') return 'Vinculado';
      if(estado === '4') return 'Validado';
      return '-';
    }
  }
}
</script>




<style>
.card-labs .item-label {
  width: 140px;
  margin-left: 10px;
}

.card-labs .card-button {
  margin-left: 8px;
  padding: 5px;
}

</style>